export var getPrimarySubscription = function getPrimarySubscription(client) {
  var axiosRequestArgs = {
    url: 'https://api.onepeloton.com/api/user/primary_subscription'
  };
  return client.request(axiosRequestArgs);
};